module.exports = __webpack_public_path__ + "img/main-facility-lounge.85313637.jpg";